<template>
    <VueDropzone
        class="dropzone dropzone-default dz-clickable dz-started"
        :accepted_file_types="['image/png', 'image/jpeg']"
        :upload_url="
            '/api/author/presentations/' + presentation.id + '/cover-image'
        "
        @uploadSuccessful="replaceCoverProps"
        @uploadFailedDueToFileTypes="showFileTypesError"
    >
        <div class="dropzone-msg dz-message needsclick">
            <h3 class="dropzone-msg-title">
                {{ translate("Upload a cover image") }}
            </h3>
            <span class="dropzone-msg-desc">{{
                translate("Only JPG and PNG files are possible")
            }}</span
            ><br />
            <span class="dropzone-msg-desc">{{
                translate("Maximum file size is 5MB")
            }}</span
            ><br />
            <span class="dropzone-msg-desc">{{
                translate(
                    "Recommended picture quality is 300 dpi for the best result.",
                )
            }}</span>
        </div>
    </VueDropzone>
</template>

<script>
import VueDropzone from "@/components/shared/VueDropzone.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";

export default {
    components: { VueDropzone },

    computed: {
        ...mapWritableState(useSubmissionWizardStore, ["presentation"]),
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["loadNavigation"]),

        // NOTE: These come from the Presentation Presenter, so they 100% match what we already have on the presentation
        // Consider moving to store, as it's shared.
        replaceCoverProps(data) {
            this.presentation.cover_image_type = data.cover_image_type;
            this.presentation.cover_image_url = data.cover_image_url;
            this.presentation.custom_cover_image_url =
                data.custom_cover_image_url;
            this.presentation.has_cover_image = data.has_cover_image;
            this.presentation.has_custom_cover_image =
                data.has_custom_cover_image;

            this.loadNavigation();
        },

        showFileTypesError() {
            this.showSwalErrorPopup("Please select only JPG or PNG files!");
        },
    },
};
</script>
